/**
 * @author Ariel
 * @description 调查问卷管理
 * @Date 2020/3/12
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import { framework_tool,component_tool } from '../../../tool';
import { WizTableForm } from '../../common'
import SurveyTemplatePreview from "../surveyTemplate/surveyTemplatePreview/surveyTemplatePreview";
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport, WizModal} = component_tool;

class SurveyManager extends WizContainer {
  componentName = 'surveyManager';

  constructor(props) {
    super(props);
    this.state = {
      addByTempVisible: false,
      tempPreviewVisible: false,
      templateData: {}
    }
    this.initialValue = {};
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'操作结果',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("操作失败，请联系相关人员")
      return false;
    }
  }

  _handleSurveyByTemp(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _onLookSurveyTemp(record) {
    this.setState({tempPreviewVisible: true,templateData: record})
  }
  //选择模版后下一步
  _addSurveyByTempSubmit = (obj, e) => {
    let surveyList = [];
    if (obj && obj['valueRows'] && obj['valueRows'].length > 0) {
      obj['valueRows'].forEach(key => {
        const {id,questionIds,title,type,img,intro,status} = key
        let survey = {
          ...key,
          channelType: "temp"
        };
        surveyList.push(survey)
      });
      if (surveyList && surveyList.length) {
        this.jumpPage("push","/biz/survey/surveyDetailAdd",{...surveyList[0]});
      }
    }
    this.setState({
      addByTempVisible: false,
    });
  }

  _onCancelTemp= (e) =>{
    this.setState({
      addByTempVisible: false,
    });
  };

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '问卷题目',
        field: 'title',
        width: 200,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '题目类型',
        field: 'type',
        width: 200,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '题目选项',
        field: 'optionContent',
        width: 200,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '题目提示信息',
        field: 'tips',
        width: 200,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '其他答案提示信息',
        field: 'otherDescribe',
        width: 200,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let surveyTitle = data.map(p=>p.surveyTitle)[0]
      let surveyType = data.map(p=>p.surveyType)[0]
      if (surveyType === 0){
        surveyType = "普通问卷"
      } else if (surveyType === 1){
        surveyType = "随堂问卷"
      } else if (surveyType === 2){
        surveyType = "回执问卷"
      } else {
        surveyType = "满意度问卷"
      }
      WizBrowserExport({
        title: surveyType+"__"+surveyTitle,
        sheetName: '问卷信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '问卷信息.xlsx',
      })
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _exportSurvey(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '问卷标题',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '问卷类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '参与人数',
        field: 'submitUserNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '问卷开始时间',
        field: 'startDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '问卷结束时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'status',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '受众',
        field: 'scope',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let _data = []
      const typeMap = { '0': '普通问卷','1': '随堂问卷','2': '回执问卷','3': '满意度问卷','4': '直播课堂问卷'}
      const statusMap = { '0': '草稿','1': '已发布','2': '已结束','3': '已关闭'}

      if(data && data instanceof Array && data.length>0){
        data.forEach(p=>{
          p['type'] = typeMap[p['type']]
          p['status'] = statusMap[p['status']]
          
          let _p = { ...p }
          let authData = p['authData']
          let target = ''
            if (authData && Object.keys(authData)) {
              if (authData['orgIds'] && authData['orgIds'].length) {
                target += ' 组织范围：'
                authData['orgIds'].forEach(org => {
                  target += org['name'] + ','
                });
                target += '\n'
              }
              if (authData['positionIds'] && authData['positionIds'].length) {
                target += ' 岗位：'
                authData['positionIds'].forEach(org => {
                  target += org['name'] + ','
                });
                target += '\n'
              }
              if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
                target += ' 岗位分类：'
                authData['positionCategoryIds'].forEach(org => {
                  target += org['name'] + ','
                });
                target += '\n'
              }
              if (authData['personIds'] && authData['personIds'].length) {
                target += ' 指定人员：'
                authData['personIds'].forEach(org => {
                  target += org['userName'] +'('+org['fullName'] +'),'
                });
                target += '\n'
              }
            }
            _p['scope'] = target
            _data.push(_p)
        })
      }

      WizBrowserExport({
        title: '问卷信息',
        sheetName: '问卷信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '问卷信息.xlsx',
      })
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const {surveyLoading} = this.props;
    let initialValue = this.initialValue;
    const {addByTempVisible,tempPreviewVisible,templateData} = this.state;
    const {id} = initialValue;
    let _templateConfig = templateConfig({
      id: id,
      self:this
    });
    let _reduxTemplateCofig = reduxTemplateCofig({
      id: id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        enable: this._handleSurveyByTemp,
        delete: this._handleCMD,
        addByTemp: this._handleSurveyByTemp,
        exportSurvey: this._exportSurvey
      }
    });
    return <>
        <WizReduxTemplate {..._reduxTemplateCofig} />
      <div style={{position:"fixed",zIndex: 1000}}>
                          <WizModal destroyOnClose
                                    key={new Date().getTime()}
                                    width={700} title={"问卷模版预览"}
                                    visible={tempPreviewVisible}
                                    onOk={() => {this.setState({tempPreviewVisible: false})}}
                                    onCancel={() => {this.setState({tempPreviewVisible: false})}}
                          >
                            <SurveyTemplatePreview templateData={templateData}/>
                          </WizModal>
      </div>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(SurveyManager);
